module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9566.871aa945.jpg";